import axios from 'axios';
import env from '@/config/env';

/**
 * Client HTTP public (sans JWT) pour les endpoints de paiement.
 * Utilisé par les pages /payment/:token accessibles sans authentification.
 */
const publicAxios = axios.create({
  baseURL: env.PUBLIC_API_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

export interface PaymentTokenMetadata {
  vehicleBrand?: string;
  vehicleModel?: string;
  monthlyAmount?: number;
  duration?: number;
  totalAmount?: number;
  serviceFees?: number;
  sellingPrice?: number;
  companyName?: string;
  companyLogo?: string;
  companyCode?: string;
}

export interface PaymentTokenStripeData {
  requiresSignature?: false;
  intentType: 'setup_intent' | 'payment_intent';
  clientSecret: string;
  stripeAccountId: string;
  paymentMethod: string | null;
  metadata: PaymentTokenMetadata | null;
  isDemo?: boolean;
}

/**
 * Renvoyé quand le contrat attend encore une signature électronique.
 * Le frontend doit rediriger le navigateur vers `signatureLink`.
 */
export interface PaymentTokenSignatureRequiredData {
  requiresSignature: true;
  signatureLink: string;
}

export type PaymentTokenData =
  | PaymentTokenStripeData
  | PaymentTokenSignatureRequiredData;

export const paymentApi = {
  /** Résout un token et retourne les données Stripe ou un ordre de redirection signature */
  resolveToken: async (token: string): Promise<PaymentTokenData> => {
    const { data } = await publicAxios.get<PaymentTokenData>(`/payment-tokens/${token}`);
    return data;
  },

  /** Marque un token comme utilisé après paiement réussi */
  completePayment: async (token: string): Promise<void> => {
    await publicAxios.post(`/payment-tokens/${token}/complete`);
  },
};
